import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPosts } from '../../services/post'
import { Post } from '../../types/postTypes'
import { RootState } from "../store/index";
import { fecthPosts } from './postApi'

export interface Appstate {
  postList: Post[],
  status: string,

  
  userEmail: string;


}

const initialState: Appstate = {

  postList: [],
  status: "idle",
  userEmail: "",


};

export const getPostsAsync = createAsyncThunk(
  'app/getPost',
  async () => {
    const response = await getPosts();
    return response.data
  }
)

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {

    setUserEmailToState: (state, action) => {
      console.log(action.payload);
      state.userEmail = action.payload;
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(getPostsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getPostsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.postList = action.payload
      });
  },
});

export default appSlice.reducer;
//select ediyor reduxtan

export const selectUserEmail = (state: RootState) => state.app.userEmail;



//dispatch ediyor
export const setUserEmailToState = appSlice.actions.setUserEmailToState;

export const selectPostList = (state: RootState) => state.app.postList;

